module.exports = __webpack_public_path__ + "img/grx_android_store.931a59f2.svg";